import { render, staticRenderFns } from "./switchInfo.vue?vue&type=template&id=72b6bb96&scoped=true"
import script from "./switchInfo.vue?vue&type=script&lang=js"
export * from "./switchInfo.vue?vue&type=script&lang=js"
import style0 from "./switchInfo.vue?vue&type=style&index=0&id=72b6bb96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b6bb96",
  null
  
)

export default component.exports